module.exports = __webpack_public_path__ + "6e6c895d253b0629b545c246d68757d1.svg";